import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import type { BreakdownResult } from '../../types/analytics.types';
import { formatNumber } from '../../lib/formatters';
import { CHART_COLORS } from '../../lib/visualizationSelector';

interface DonutChartDisplayProps {
  data: BreakdownResult;
}

export function DonutChartDisplay({ data }: DonutChartDisplayProps) {
  const { groups, totalCount } = data;

  const chartData = groups.map((group, index) => ({
    name: group.label,
    value: group.count,
    percentage: group.percentage,
    fill: CHART_COLORS.categorical[index % CHART_COLORS.categorical.length],
  }));

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      return (
        <div className="bg-popover border rounded-lg shadow-lg p-3">
          <p className="font-medium text-foreground">{item.name}</p>
          <p className="text-sm text-muted-foreground">
            {formatNumber(item.value)} patients ({item.percentage.toFixed(1)}%)
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="flex items-center gap-6">
      <ResponsiveContainer width="60%" height={250}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={100}
            paddingAngle={2}
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>

      <div className="flex-1 space-y-2">
        {chartData.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <div
              className="w-3 h-3 rounded-full flex-shrink-0"
              style={{ backgroundColor: item.fill }}
            />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{item.name}</div>
              <div className="text-xs text-muted-foreground">
                {formatNumber(item.value)} ({item.percentage.toFixed(1)}%)
              </div>
            </div>
          </div>
        ))}
        <div className="pt-2 border-t">
          <div className="text-sm text-muted-foreground">
            Total: {formatNumber(totalCount)} patients
          </div>
        </div>
      </div>
    </div>
  );
}
